/**
 * @package  	Cavalree_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
    var $ = jQuery;
}

/*****************************
 * Yoast Accordions
 *****************************/
jQuery(document).ready(function() {
	jQuery('.wp-block-yoast-faq-block .schema-faq-question').click(function(){
		if (jQuery(this).siblings('.schema-faq-answer').is(':visible')) {
			jQuery(this).removeClass('faq-q-open');
			jQuery(this).siblings('.schema-faq-answer').removeClass('faq-a-open').slideUp();
	}
	else {
		jQuery(this).addClass('faq-q-open');
		jQuery(this).siblings('.schema-faq-answer').addClass('faq-a-open').slideDown();
		}
	})
});


/*****************************
 * Flippable Cards
 *****************************/

$('.card--flip').on('click', function () {
    $(this).toggleClass('flipped');
});

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
detectScrollbarWidth();
// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {

});

// END jQuery Ready
function detectScrollbarWidth() {
    /* Detect scrollbar width to properly center full- and wide-width elements */
    let root = document.documentElement;
    var outside = document.createElement("div");
    var inside = document.createElement("div");
    
    outside.style.width = inside.style.width = "100%";
    outside.style.overflow = "scroll";
    document.body.appendChild(outside).appendChild(inside);
    
    var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;
    
    outside.parentNode.removeChild(outside);
    root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function addHeadingNonBreakingSpace() {
    var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

    headings.forEach(function (head, index) {
        let str = head.textContent;
        let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
        let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

        firstSection = firstSection.trim();

        let newStr = firstSection + "\u00a0" + lastSection;

        head.innerHTML = newStr;
    });
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('button[data-action="open"]').forEach(openBtn => {
    openBtn.addEventListener("click", event => {
      const section = event.target.closest("header.hero");
      if (!section) return;
      
      let dialog = section.previousElementSibling;
      if (!dialog || dialog.tagName.toLowerCase() !== "dialog") {
        dialog = section.nextElementSibling;
      }
      
      if (dialog && dialog.tagName.toLowerCase() === "dialog") {
        dialog.showModal();
      } else {
        console.warn("No corresponding <dialog> element found.");
      }
    });
  });

  document.querySelectorAll('button[data-action="close"]').forEach(closeBtn => {
    closeBtn.addEventListener("click", event => {
      const dialog = event.target.closest("dialog");
      if (dialog) {
        dialog.close();
      }
    });
  });

  document.querySelectorAll("dialog").forEach(dialog => {
    dialog.addEventListener("click", event => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('dialog').forEach(dialog => {
    const iframe = dialog.querySelector('iframe[src*="player.vimeo.com"]');

    if (iframe) {
      const player = new Vimeo.Player(iframe);

      dialog.addEventListener('close', () => {
        player.pause()
      });
    }
  });
});
